import { useEffect, useId } from 'react'

// 避免兩組彈窗時，關閉其中一個就觸發還原捲軸
const ids: Set<string> = new Set()

/**
 * 隱藏 body 捲軸，彈窗時用，直接掛頂層，銷燬時自動清除
 */
export const useHideBodyScroll = (status: boolean = true) => {
  const id = useId()

  /** 隱藏捲軸 */
  useEffect(() => {
    if (!status) return

    // 隱藏捲軸
    ids.add(id)
    document.body.classList?.add('overflow-hidden', 'overscroll-y-none', 'overscroll-y-none')

    return () => {
      ids.delete(id)

      // 還原捲軸
      if (ids.size <= 0) {
        document.body.classList?.remove('overflow-hidden', 'overscroll-y-none', 'overscroll-y-none')
      }
    }
  }, [status])
}
